// ── Counter Pump — Entry Point ──
// Initializes the game and handles top-level error reporting.

import { Game } from './game';
import { applyMobileHUD } from './ui/mobile-hud';
import { applyMobileControlsHint } from './ui/mobile-controls-hint';
import { registerServiceWorker, attachInstallPrompt } from './pwa';

async function main(): Promise<void> {
  // Apply mobile HUD CSS overrides immediately at startup so the main menu
  // paints with the responsive rules from the first frame (no desktop->mobile
  // reflow flash on phones). Cleanup fn intentionally not stored — the styles
  // live for the lifetime of the page (matches existing Game lifecycle).
  void applyMobileHUD();
  applyMobileControlsHint();

  // F-MOB-C4 / MOB-W9: register service worker + capture beforeinstallprompt
  // so we can show an install button on mobile.
  registerServiceWorker();
  attachInstallPrompt();

  const game = new Game();

  try {
    await game.init();
  } catch (err) {
    console.error('Failed to initialize game:', err);
    const menu = document.getElementById('main-menu');
    if (menu) {
      menu.innerHTML = `
        <h1 style="color: #e94560; font-size: 48px; letter-spacing: 4px;">Counter Pump</h1>
        <p style="color: #ff6b6b; margin-top: 20px;">Failed to initialize game</p>
        <p style="color: #666; margin-top: 10px; font-size: 14px;">${String(err)}</p>
        <button onclick="location.reload()" style="margin-top: 20px; padding: 10px 40px; background: #e94560; color: #fff; border: none; cursor: pointer;">Retry</button>
      `;
    }
    return;
  }

  // Clean up on page unload
  window.addEventListener('beforeunload', () => {
    game.dispose();
  });
}

main();
